import { WearableModalType } from "../types"
import WearableContentInfo from "../WearableContentInfo"
import { Icon, IconColor } from "@/components/shared/Icon"
import { getBatteryChargeIcon } from "@/utils/index"

export const WearableScannedInfo = ({
   wearableId,
   batteryPercentage,
}: {
   wearableId: string
   batteryPercentage?: number | null
}) => {
   return (
      <WearableContentInfo
         type={WearableModalType.SCANNED}
         description={
            <div className="wearable-content-info__description wearable-content-info__description--scanned">
               The scanned ReassureBand <span>{wearableId}</span>{" "}
               {batteryPercentage != null && (
                  <span className="wearable-content-info__battery">
                     <Icon
                        name={getBatteryChargeIcon(batteryPercentage)}
                        color={IconColor.WHITE}
                        size="16"
                     />
                     <span>{batteryPercentage}%</span>
                  </span>
               )}{" "}
               has not been assigned to an inmate yet.
            </div>
         }
      />
   )
}
